import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { Hero } from "./components/Hero";
import { OfferTeaser } from "./components/OfferTeaser";
import { BeforeAfter } from "./components/BeforeAfter";
import { PainPoints } from "./components/PainPoints";
import { Volumes } from "./components/Volumes";
import { Library } from "./components/Library";
import { Bonuses } from "./components/Bonuses";
import { Offer } from "./components/Offer";
import { Guarantee } from "./components/Guarantee";
import { Testimonials } from "./components/Testimonials";
import { AuthorMessage } from "./components/AuthorMessage";
import { FAQ } from "./components/FAQ";
import { FinalCTA } from "./components/FinalCTA";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { PurchasePopup } from "./components/PurchasePopup";
export function App() {
  return <div className="w-full overflow-x-hidden bg-navy-950 font-sans" data-id="element-0" data-mp="23w4ek0vqj40u">
      <MetaPixel data-id="element-1" data-mp="3ijxsgzk2wgo4" />
      <Hero data-id="element-2" data-mp="3ikh5c1uvgeva" />
      <main data-id="element-3" data-mp="3iiweonbohg2p">
        <OfferTeaser data-id="element-4" data-mp="3ij61y35c994p" />
        <BeforeAfter data-id="element-5" data-mp="3ihv2gfixenje" />
        <PainPoints data-id="element-6" data-mp="3mlj98vzqhf3l" />
        <Volumes data-id="element-7" data-mp="3ml17jjuay8oa" />
        <Library data-id="element-8" data-mp="3mkhofzsx1e8o" />
        <Bonuses data-id="element-9" data-mp="3mjzpgvevclx2" />
        <Offer data-id="element-10" data-mp="3mjgclt42snpw" />
        <Guarantee data-id="element-11" data-mp="3rc9co3oln7vn" />
        <Testimonials data-id="element-12" data-mp="3rbrcwx2qabiz" />
        <AuthorMessage data-id="element-13" data-mp="3rdkgg3i1ofmr" />
        <FAQ data-id="element-14" data-mp="3recerm310rgq" />
        <FinalCTA data-id="element-15" data-mp="3relw6la09qat" />
      </main>
      <Footer data-id="element-16" data-mp="6htjo98ovic" />
      <FloatingCTA data-id="element-17" data-mp="4wwnrzgd0hb" />
      <PurchasePopup data-id="element-18" data-mp="5gbv0xpxarn" />
    </div>;
}